import { createAction } from '@reduxjs/toolkit';
import {
  CreatePollTemplatePayload,
  EditPollPayload,
  EditPollTemplatePayload,
  Poll,
  PollPayload,
  PollTemplate,
  VotePayload,
  VoteResponse,
} from 'features/polls/types';
import { EntityIdPayload, SignalingEventPayload } from 'services/signaling';

export const createPollRequested = createAction<PollPayload>('polls/createPollRequested');

export const signalingPollCreated = createAction<Poll>('signaling/poll/created');

export const launchPollRequested = createAction<string>('polls/launchPollRequested');
export const signalingPollLaunched =
  createAction<SignalingEventPayload<Poll>>('signaling/poll/launched');

export const endPollRequested = createAction<string>('polls/endPollRequested');
export const signalingPollEnded = createAction<EntityIdPayload>('signaling/poll/ended');

export const signalingPollsReceived = createAction<{
  polls: Poll[];
}>('signaling/poll/received');

export const deletePollRequested = createAction<string>('polls/deletePollRequested');
export const signalingPollDeleted = createAction<EntityIdPayload>('signaling/poll/deleted');

export const votePollRequested = createAction<VotePayload>('polls/votePollRequested');
export const signalingPollVoted = createAction<VoteResponse>('signaling/poll/voted');

export const sharePollResultsRequested = createAction<string>('polls/shareResultsRequested');
export const signalingPollResultsShared = createAction<
  SignalingEventPayload<Poll | EntityIdPayload>
>('signaling/poll/resultsShared');

export const stopSharingPollResultsRequested = createAction<string>(
  'polls/stopSharingResultsRequested'
);
export const signalingPollResultsSharingStopped = createAction<EntityIdPayload>(
  'signaling/poll/resultsSharingStopped'
);

export const editPollRequested = createAction<EditPollPayload>('polls/editPollRequested');
export const signalingPollEdited = createAction<Poll>('signaling/poll/edited');

export const clonePollRequested = createAction<string>('polls/clonePollRequested');

export const exportSinglePollRequested = createAction<string>('polls/exportSinglePollRequested');

export const pollResultsCleared = createAction<{ canManagePolls: boolean }>(
  'polls/pollResultsCleared'
);

export const signalingPollTemplatesReceived = createAction<{ templates: PollTemplate[] }>(
  'signaling/poll/templatesReceived'
);

export const signalingPollTemplateCreated = createAction<PollTemplate>(
  'signaling/poll/templateCreated'
);

export const signalingPollTemplateEdited = createAction<PollTemplate>(
  'signaling/poll/templateEdited'
);

export const signalingPollTemplateDeleted = createAction<EntityIdPayload>(
  'signaling/poll/templateDeleted'
);

export const createPollTemplateRequested = createAction<CreatePollTemplatePayload>(
  'polls/createTemplateRequested'
);

export const editPollTemplateRequested = createAction<EditPollTemplatePayload>(
  'polls/editTemplateRequested'
);

export const deletePollTemplateRequested = createAction<EntityIdPayload>(
  'polls/deleteTemplateRequested'
);

export const addPollToRoomFromTemplateRequested = createAction<EntityIdPayload>(
  'polls/addToRoomFromTemplateRequested'
);

export const downloadPollTemplateRequested = createAction('polls/downloadPollTemplateRequested');

export const importPollCsvRequested = createAction<File>('polls/importPollCsvRequested');

export const importPollTemplateCsvRequested = createAction<File>(
  'polls/importPollTemplateCsvRequested'
);
